
document.addEventListener('DOMContentLoaded' , () =>{
	//header gnb
	const body = document.body,
		  gnbOpenBtn = document.querySelectorAll('.js-gnb-open'),
		  gnbCloseBtn = document.querySelector('.js-gnb-close'),
		  gnbToggleBtn = document.querySelectorAll('.js_gnb_toggleBtn');

	if(document.querySelector('.gnb')){
		gnbOpenBtn.forEach(function(el){
			el.addEventListener('click' , function(){
				body.classList.add('ovf');
				$(".js-gnb").show(100, function(){
					$(".js-gnb .gnb__content").stop().animate({"left":"0"}, 450);
				});

				gnbToggleBtn.forEach(function(el){
					let gnbToggleBtnArray = Array.from(el.parentNode.parentNode.querySelectorAll('.js_gnb_toggleBtn'));

					el.addEventListener('click' , function(e){
						if(el.classList.contains('active')){
							el.classList.remove('active');
						}else{
							gnbToggleBtnArray.forEach(function(el){
								el.classList.remove('active');
							});
							el.classList.add('active');
						}
					});
					console.log("재실행");
				})

				gnbCloseBtn.addEventListener('click' , function(){
					body.classList.remove('ovf');
					$(".js-gnb .gnb__content").stop().animate({"left":"-100%"}, 450);
					setTimeout(function(){
						$(".js-gnb").hide();
					}, 450);
				});
			});
		})
	}

	//header menu
	if(document.querySelector('.header__menu')){
		const headerMenu = new Swiper('.header-menu-swiper', {
			slidesPerView: 'auto',
			freeMode: true,
			loop: false,
		})

		// let headerMenuLine = document.querySelector('.header__menu__line'),
		// 	headerMenuLi = document.querySelectorAll('.header__menu__list>li'),
		// 	savedLeft = localStorage.getItem('offetLeft');

		// //이전 페이지 li.on left 수치 저장한게 있으면 적용
		// if(savedLeft){
		// 	headerMenuLine.style.left = savedLeft;
		// }

        // headerMenuLi.forEach(function(el){
		// 	if(el.classList.contains('on')){
		// 		console.log(el)
		// 		console.log(el.offsetWidth)
		// 		console.log(el.offsetLeft)
		// 		let targetWidth = el.offsetWidth,
		// 			targetLeft = el.offsetLeft;

		// 		headerMenuLine.style.width = targetWidth + 'px';
		// 		headerMenuLine.style.left = targetLeft + 'px';
		// 	}else{
		// 	}
		// });

		// //현재 페이지 li.on left 수치 저장
		// window.addEventListener('beforeunload', () => {
		// 	const computedStyle = window.getComputedStyle(headerMenuLine);
		// 	const currentLeft = computedStyle.left;
		// 	localStorage.setItem('offetLeft', currentLeft);
		// });
	}

	//header nav
	if(document.querySelector('.nav')){
        let swiper = new Swiper('.nav', {
            slidesPerView: 'auto',
            spaceBetween: 1,
        });
	}

	//header height
	let contentH = document.querySelector('.content');

	if (!contentH) return;

	const header = document.querySelector('.header');
	const lnb = document.querySelector('.lnb');
	const topArea = document.querySelector('.top-area');

	if (header && header.offsetHeight > 0) {
		contentH.style.marginTop = header.offsetHeight + 'px';
	} else if (lnb && lnb.offsetHeight > 0) {
		contentH.style.marginTop = lnb.offsetHeight + 'px';
	} else if (topArea && topArea.offsetHeight > 0) {
		contentH.style.marginTop = topArea.offsetHeight + 'px';
	}
	
	// 비밀번호 보기
	const hiddenShow = document.querySelectorAll('.js_hiddenShow');

	class hiddenShowBox {
		constructor(target) {
			this.target = target;
			this.hiddenShowBtn = this.target.querySelector('.hidden-show__btn');
			this.hiddenShowIp = this.target.querySelector(".hidden-show__input");
		}

		hiddenShowFn() {
			const _this = this;
			
			this.hiddenShowBtn.addEventListener("click" , function(){
				if(_this.hiddenShowIp.type === 'password'){
					_this.hiddenShowIp.type = 'text';
					_this.hiddenShowBtn.classList.add('on');
				}else{
					_this.hiddenShowIp.type = 'password';
					_this.hiddenShowBtn.classList.remove('on');
				}
			})
		}
	}    
	hiddenShow.forEach(el => {        
		new hiddenShowBox(el).hiddenShowFn();
	});

	//datepicker
	if(document.querySelector('.datepicker')){
		$(".datepicker input").datepicker({
			dateFormat: 'yy-mm-dd',
			showOtherMonths: true,
			prevText: '이전 달',
			nextText: '다음 달',
			monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			dayNames: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
			showMonthAfterYear: true,
			yearSuffix: '',
			firstDay:1
		});
	}

	//image-banner
	if(document.querySelector('.image-banner')){
		const imageBanner = new Swiper('.image-banner', {
			slidesPerView: 1,
			loop: false,
			pagination: {
				el: ".swiper-pagination",
			},
		})
	}

	//text-banner
	// if(document.querySelector('.text-banner')){
	// 	$(".text-banner").slick({
	// 		arrows:false,
	// 		dots:false,
	// 		vertical:true,
	// 		verticalSwiping:true,
	// 		autoplay: true,
	// 		autoplaySpeed: 3000,
	// 	});
	// }

	//category menu - product, brand
	if(document.querySelector('.category')){
		$(".category .category__menu").slick({
			arrows:false,
			dots:false,
			variableWidth:true,
			infinite:false,
			slidesToShow:1,
			swipeToSlide:true,
		});
	}

	// footer - floating 상단으로
	if(document.querySelector('.top-move')){
		const topMove = document.querySelector('.top-move');

		window.addEventListener('scroll' , ()=>{
			if(window.pageYOffset >= topMove.clientHeight){
				topMove.classList.add('scroll');
			} else {
				topMove.classList.remove('scroll');
			}
		})
	}
});
